<template>
  <section class="section-book-additional-hours p-4">
    <!-- Navigation -->
    <div class="row mb-3">
      <div class="col-12 col-md-8 offset-md-2">
        <router-link to="/my-reservations" class="text-primary-link">
          {{ $t('message.menu.my_reservations') }}
        </router-link>
        <i class="fal fa-angle-right"></i>
        <router-link class="text-primary-link" :to="`/reservation/${order.id}`">
          {{ $t('message.my_reservations.reservation_detail') }}
        </router-link>
        <i class="fal fa-angle-right"></i>
        {{ $t('message.my_reservations.additional_hours') }}
      </div>
    </div>
    <div class="row pt-4">
      <div class="col-12 col-lg-6 offset-lg-3">
        <div class="row d-flex align-items-center">
          <div class="col-4 p-0">
            <label class="mb-0">{{ $t('message.my_reservations.additional_hours') }}:</label>
          </div>
          <div class="col-8 p-0">
            <div class="select-jumbo" v-if="parentServiceId">
              <select v-model="selectedData" @change="reCalculateCost">
                <option :value="duration" v-for="duration in durations">
                  {{ duration.text }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div v-if="subtotal">
          <hr/>
          <div class="row text-secondary">
            <div class="col-6 p-0">
              {{ $t('message.my_reservations.summary_total.subtotal') }}
            </div>
            <div class="col-6 p-0 text-right">
              {{ subtotal | currency }}
            </div>
          </div>
          <div class="row mt-1 text-secondary">
            <div class="col-6 p-0">
              {{ $t('message.my_reservations.summary_total.service_vat') }}
            </div>
            <div class="col-6 p-0 text-right">
              {{ (subtotal * globalState.serviceVat) | currency }}
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-6 p-0">
              <label>{{ $t('message.my_reservations.summary_total.total') }}</label>
            </div>
            <div class="col-6 p-0 text-right">
              <label>{{ totalPrice | currency }}</label>
            </div>
          </div>
        </div>
        <hr/>
        <payment-methods ref="paymentMethods"
                         @onSelectedPaymentMethod="updatePaymentMethod"
                         @onSelectedCreditCard="applyUserCreditCard"
                         @onRequestedSavingTempData="saveTempData"
                         @onSelectedFileUpload="setFileUpload"
                         @onRequestedUpdatingQrResponse="updateQrResponse"
                         @onSuccessQrPayment="displaySuccessDialog"></payment-methods>
        <div class="pt-2">
          <button class="btn btn-info btn-block"
                  :disabled="isLoading"
                  v-if="paymentMethod !== 'promptpay'"
                  @click="saveAdditionalHours()">
            {{ isLoading ? $t('message.button.loading') : $t('message.button.submit_booking') }}
          </button>
        </div>

      </div>
    </div>

  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { orderMixin } from '../../mixins/orderMixin'
  import PaymentMethods from './PaymentMethods'
  import axios from 'axios'

  export default {
    mixins: [orderMixin],
    components: {
      PaymentMethods
    },
    data () {
      return {
        orderAdditionalHoursId: null,
        parentServiceId: null,
        durations: null,
        selectedData: null,
        selectedWorkHour: '0.5',
        subtotal: null,
        serviceVat: null,
        totalPrice: null,
        paymentMethod: null,
        omiseCustomerId: null,
        isLoading: false
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        order: 'orderDetail/getOrderDetail',
        user: 'auth/getUser'
      }),
      ...mapState('orderDetail', ['isSavingAdditionalHours', 'tmpAdditionalHoursBookingData'])
    },
    watch: {
      totalPrice () {
        this.updateQrPayment()
      },
      paymentMethod () {
        this.updateQrPayment()
      }
    },
    methods: {
      updatePaymentMethod (paymentMethod) {
        this.paymentMethod = paymentMethod
      },
      async updateQrPayment () {
        if (this.paymentMethod === 'promptpay') {
          const url = (!this.orderAdditionalHoursId) ? 'order-additional-hours' : `order-additional-hours/${this.orderAdditionalHoursId}/update-payment`
          const submitData = {
            user_id: this.user.id,
            order_id: this.order.id,
            service_id: this.selectedData.service_id,
            work_hour: this.selectedData.work_hour,
            payment_method: this.paymentMethod
          }
          const {data} = await axios.post(url, submitData)
          if (data.error) {
            this.$swal({text: data.message, type: 'error'})
          } else {
            const qrPaymentData = {
              order_additional_hours_id: data.order_additional_hours.id,
              amount: this.totalPrice
            }
            this.$refs.paymentMethods.updateQrPaymentData(qrPaymentData)
          }
        }
      },
      setFileUpload (file) {
        this.fileUpload = file
      },
      saveTempData () {
        // Set temp additional hours booking data
        const additionalHoursBookingData = {
          user_id: this.user.id,
          order_id: this.order.id,
          order_additional_hours_id: this.orderAdditionalHoursId,
          service_id: this.selectedData.service_id,
          work_hour: this.selectedData.work_hour,
          payment_method: this.paymentMethod
        }
        this.$store.commit('orderDetail/SET_TMP_ADDITIONAL_HOURS_BOOKING_DATA', additionalHoursBookingData)
      },
      applyUserCreditCard (data) {
        this.paymentMethod = data.payment_method
        this.omiseCustomerId = data.omise_customer_id
      },
      getParentServiceId () {
        this.parentServiceId = this.order.service_id
        if (this.globalState.services[this.order.service_id].parent_id > 0) {
          this.parentServiceId = this.globalState.services[this.order.service_id].parent_id
        }
        this.getDurations()
      },
      getDurations () {
        if (this.parentServiceId === 1) {
          this.durations = [
            {
              service_id: 1,
              work_hour: 0.5,
              text: `30 ${this.$i18n.t('message.minutes')}`,
              cost: 0.5 * this.order.cost_per_hour
            },
            {
              service_id: 1,
              work_hour: 1.0,
              text: `1 ${this.$i18n.tc('message.hour', 1)}`,
              cost: 1.0 * this.order.cost_per_hour
            },
            {
              service_id: 1,
              work_hour: 1.5,
              text: `1 ${this.$i18n.tc('message.hour', 1)} 30 ${this.$i18n.t('message.minutes')}`,
              cost: 1.5 * this.order.cost_per_hour
            },
            {
              service_id: 1,
              work_hour: 2.0,
              text: `2 ${this.$i18n.tc('message.hour', 2)}`,
              cost: 2.0 * this.order.cost_per_hour
            },
            {
              service_id: 1,
              work_hour: 2.5,
              text: `2 ${this.$i18n.tc('message.hour', 2)} 30 ${this.$i18n.t('message.minutes')}`,
              cost: 2.5 * this.order.cost_per_hour
            },
            {
              service_id: 1,
              work_hour: 3.0,
              text: `3 ${this.$i18n.tc('message.hour', 3)}`,
              cost: 3.0 * this.order.cost_per_hour
            },
            {
              service_id: 1,
              work_hour: 3.5,
              text: `3 ${this.$i18n.tc('message.hour', 3)} 30 ${this.$i18n.t('message.minutes')}`,
              cost: 3.5 * this.order.cost_per_hour
            },
            {
              service_id: 1,
              work_hour: 4.0,
              text: `4 ${this.$i18n.tc('message.hour', 4)}`,
              cost: 4.0 * this.order.cost_per_hour
            },
            {
              service_id: 1,
              work_hour: 4.5,
              text: `4 ${this.$i18n.tc('message.hour', 4)} 30 ${this.$i18n.t('message.minutes')}`,
              cost: 4.5 * this.order.cost_per_hour
            },
            {
              service_id: 1,
              work_hour: 5.0,
              text: `5 ${this.$i18n.tc('message.hour', 5)}`,
              cost: 5.0 * this.order.cost_per_hour
            },
            {
              service_id: 1,
              work_hour: 5.5,
              text: `5 ${this.$i18n.tc('message.hour', 5)} 30 ${this.$i18n.t('message.minutes')}`,
              cost: 5.5 * this.order.cost_per_hour
            },
            {
              service_id: 1,
              work_hour: 6.0,
              text: `6 ${this.$i18n.tc('message.hour', 6)}`,
              cost: 6.0 * this.order.cost_per_hour
            }
          ]
        } else {
          this.durations = []
          for (let key in this.globalState.services) {
            const service = this.globalState.services[key]
            const provinceId = service.province_id
            if (service.parent_id === this.parentServiceId && (provinceId === 0 || provinceId === this.order.province_id)) {
              const strText = service.duration + ' ' + this.$i18n.tc('message.hour', service.duration)
              const data = {
                service_id: service.id,
                work_hour: service.duration,
                text: strText,
                cost: service.cost
              }
              this.durations.push(data)
            }
          }
          this.durations = this._.orderBy(
            this.durations,
            ['work_hour'],
            ['asc']
          )
        }
        this.selectedData = this.durations[0]
        this.reCalculateCost()
      },
      reCalculateCost () {
        this.subtotal = this.selectedData.cost
        this.serviceVat = Math.round((this.subtotal * this.globalState.serviceVat) * 100) / 100
        this.totalPrice = Number(this.subtotal) + Number(this.serviceVat)
      },
      saveAdditionalHours () {
        if (this.paymentMethod) {
          switch (this.paymentMethod) {
            case 'credit_card':
              if (!this.omiseCustomerId) {
                this.$swal({text: this.$i18n.t('message.alert.select_credit_card')})
              } else {
                this.addAdditionalHours()
              }
              break
            case 'bank_transfer':
              if (!this.fileUpload) {
                const alertMessage = this.$i18n.t('message.alert.no_file_upload')
                this.$swal({text: alertMessage, type: 'error'})
              } else {
                this.addAdditionalHours()
              }
              break
          }
        } else {
          this.$swal({text: this.$i18n.t('message.alert.select_payment_method')})
        }
      },
      async addAdditionalHours () {
        this.isLoading = true
        const submitData = {
          user_id: this.user.id,
          order_id: this.order.id,
          service_id: this.selectedData.service_id,
          work_hour: this.selectedData.work_hour,
          payment_method: this.paymentMethod,
          omise_customer_id: this.omiseCustomerId
        }
        const url = (!this.orderAdditionalHoursId) ? 'order-additional-hours' : `order-additional-hours/${this.orderAdditionalHoursId}/update-payment`
        const {data} = await axios.post(url, submitData)
        if (!data.error) {
          this.orderAdditionalHoursId = data.order_additional_hours.id
          if (this.paymentMethod === 'credit_card' || this.paymentMethod === 'promptpay') {
            this.isLoading = false
            // Display success dialog
            this.displaySuccessDialog()
          } else if (this.paymentMethod === 'bank_transfer') {
            await this.submitFileUpload(this.orderAdditionalHoursId)
          }
        } else {
          switch (data.error_case) {
            case 'INVALID_CREDIT_CARD':
              this.$swal({text: this.$i18n.t('message.alert.invalid_credit_card'), type: 'error'})
              break
            case 'CLEANER_CHECKED_OUT':
              this.$swal({text: this.$i18n.t('message.alert.cleaner_checked_out'), type: 'error'})
              break
            case 'NO_DATA':
              this.$swal({text: this.$i18n.t('message.alert.cannot_book_additional_hours'), type: 'error'})
              break
          }
        }
      },
      async submitFileUpload (orderAdditionalHoursId) {
        let formData = new FormData()
        formData.append('upload_image', this.fileUpload)
        const url = `order-additional-hours/${orderAdditionalHoursId}/bank-transfer`
        const {data} = await axios.post(url, formData)
        if (!data.error) {
          this.isLoading = false
          // Display success dialog
          const alertMessage = this.$i18n.t('message.payment_method.bank_transfer_success')
          this.displaySuccessDialog(alertMessage)
        } else {
          this.$swal({text: data.message, type: 'error'})
        }
      },
      displaySuccessDialog (alertMessage = this.$i18n.t('message.payment_method.payment_success')) {
        if (this.tmpAdditionalHoursBookingData) {
          this.$store.commit('orderDetail/SET_TMP_ADDITIONAL_HOURS_BOOKING_DATA', null)
        }
        this.$swal({
          text: alertMessage,
          type: 'success',
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonColor: '#17a2b8',
          confirmButtonText: this.$i18n.t('message.button.close')
        }).then((result) => {
          if (result) {
            this.$router.push(`/reservation/${this.order.id}`)
          }
        })
      },
      updateQrResponse (qrResponse) {
        if (qrResponse.qr_payment && qrResponse.qr_payment.order_additional_hours_id) {
          this.orderAdditionalHoursId = Number(qrResponse.qr_payment.order_additional_hours_id)
        }
      }
    },
    mounted () {
      this.getParentServiceId()
      // Check temp booking from adding new card
      if (this.tmpAdditionalHoursBookingData) {
        this.selectedData = this._.find(this.durations, {work_hour: Number(this.tmpAdditionalHoursBookingData.work_hour)})
        setTimeout(() => {
          this.paymentMethod = this.tmpAdditionalHoursBookingData.payment_method
          this.$refs.paymentMethods.setPaymentMethod(this.paymentMethod)
        }, 500)
        this.reCalculateCost()
      }
      // Check order additional hours request from professional
      if (this.$route.query.id) {
        this.orderAdditionalHoursId = Number(this.$route.query.id)
        if (this.orderAdditionalHoursId && this.order.book_more_hours[0] && this.order.book_more_hours[0].id === this.orderAdditionalHoursId) {
          this.selectedData = this._.find(this.durations, {work_hour: Number(this.order.book_more_hours[0].work_hour)})
          this.reCalculateCost()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/BookAdditionalHours.vue